import React from "react";
import { Phone, MapPin, Mail } from "lucide-react";
import { SALON } from "../data/salonData";

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 overflow-hidden"
    >
      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 lg:px-12 text-center">
        <div className="flex items-center justify-center gap-3 mb-7 reveal">
          <span className="divider-bloom">
            <span className="font-serif-italic tracking-wide text-[1.4rem] sm:text-[1.6rem] font-bold">
              {SALON.slogan}
            </span>
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="font-display text-[2.5rem] sm:text-5xl lg:text-[4.4rem] leading-[1.05] tracking-tight text-luxuryBlack reveal"
        >
          Kinjal&rsquo;s Beauty &amp; Hair
        </h1>

        <h2
          data-testid="hero-subheading"
          className="mt-5 font-display text-xl sm:text-2xl lg:text-3xl leading-snug text-luxuryBlack/85 reveal"
        >
          Professional Beauty &amp; Hair Salon in{" "}
          <span className="hero-script">Glen Eden, Auckland</span>
        </h2>

        <p
          data-testid="hero-subheadline"
          className="mt-6 max-w-xl mx-auto text-base sm:text-lg leading-relaxed text-luxuryBlack/70 reveal"
        >
          Threading, waxing, facials, hair styling and bridal beauty services.
        </p>

        {/* CTA */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 reveal">
          <a
            href={`tel:${SALON.phoneTel}`}
            data-testid="hero-call-btn"
            className="btn-primary"
          >
            <Phone className="w-5 h-5" />
            Call {SALON.phoneDisplay}
          </a>
        </div>

        {/* Quick info */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-3xl mx-auto reveal">
          <a
            href={`tel:${SALON.phoneTel}`}
            data-testid="hero-info-phone"
            className="glass-card rounded-2xl p-4 flex items-start gap-3 text-left hover:-translate-y-1 transition-transform duration-300"
          >
            <Phone className="w-5 h-5 text-roseGold mt-1 shrink-0" />
            <div>
              <div className="label-eyebrow">Phone</div>
              <div className="text-sm font-medium text-luxuryBlack">
                {SALON.phoneDisplay}
              </div>
            </div>
          </a>
          <a
            href={`mailto:${SALON.email}`}
            data-testid="hero-info-email"
            className="glass-card rounded-2xl p-4 flex items-start gap-3 text-left hover:-translate-y-1 transition-transform duration-300"
          >
            <Mail className="w-5 h-5 text-roseGold mt-1 shrink-0" />
            <div>
              <div className="label-eyebrow">Email</div>
              <div className="text-sm font-medium text-luxuryBlack break-all">
                {SALON.email}
              </div>
            </div>
          </a>
          <a
            href={SALON.mapsLink}
            target="_blank"
            rel="noreferrer"
            data-testid="hero-info-address"
            className="glass-card rounded-2xl p-4 flex items-start gap-3 text-left hover:-translate-y-1 transition-transform duration-300"
          >
            <MapPin className="w-5 h-5 text-roseGold mt-1 shrink-0" />
            <div>
              <div className="label-eyebrow">Visit</div>
              <div className="text-sm font-medium text-luxuryBlack">
                Glen Eden, Auckland
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
